import { useCallback } from 'react'
import {
	createParser,
	type inferParserType,
	parseAsArrayOf,
	parseAsBoolean,
	parseAsFloat,
	parseAsString,
	parseAsStringLiteral,
	useQueryStates,
} from 'nuqs'

export type QueryFilters = inferParserType<typeof parsers>

const parseAsTime = createParser({
	parse(queryValue) {
		return queryValue?.replace('-', ':')
	},
	serialize(value) {
		return value?.replace(':', '-')
	},
})

const parsers = {
	capacity: parseAsArrayOf(parseAsString),

	day: parseAsArrayOf(parseAsString),

	end: parseAsTime,
	features: parseAsArrayOf(parseAsString),

	isMapVisible: parseAsBoolean.withDefault(true),

	latitude: parseAsFloat,
	longitude: parseAsFloat,
	ne_latitude: parseAsFloat,
	ne_longitude: parseAsFloat,

	ref_latitude: parseAsFloat,
	ref_longitude: parseAsFloat,

	sortBy: parseAsStringLiteral(['price', 'capacity']),
	sortOrder: parseAsStringLiteral(['asc', 'desc']).withDefault('asc'),
	start: parseAsTime,
	sw_latitude: parseAsFloat,
	sw_longitude: parseAsFloat,
	text: parseAsString,
}

export const useSearchFilters = () => {
	const [filters, setFilters] = useQueryStates(parsers)

	const setIsMapVisible = useCallback(
		(isMapVisible: boolean) => {
			setFilters({ isMapVisible })
		},
		[setFilters],
	)

	const { isMapVisible, sortBy, sortOrder, ...filtersWithoutMap } = filters

	return {
		filters: filtersWithoutMap,
		isMapVisible,
		setFilters,
		setIsMapVisible,
		sortBy,
		sortOrder,
	}
}
